require('./cardChangePaymentMethodStep2.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const CardLegalViewerModal = require('components/cards/cardLegalViewerModal/cardLegalViewerModal');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');
const WebappRender = require('components/conditionalRender/webappRender');
// @ constants
const {CARD_PAYMENT_CHANGE_ID} = require('constants/operationTypes');
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE
} = require('constants/index');
const { DIAMOND_PACK_PRODUCT_NAME, PREMIUM_PACK_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');

class CardChangePaymentMethodStep2 extends React.Component {
    constructor(props) {
        super(props);

        let precontractualMailProductInfo = {
            producto: props.immCard.getIn(['product', 'type']),
            standard: props.immCard.getIn(['product', 'standard']),
            subproducto: props.immCard.getIn(['product', 'subtype']),
        };

        if (props.immCard.get('isDiamond')) {
            precontractualMailProductInfo.productName = DIAMOND_PACK_PRODUCT_NAME;
        } else if (props.immCard.get('isPremium')) {
            precontractualMailProductInfo.productName = PREMIUM_PACK_PRODUCT_NAME;
        }

        this.state = {
            amount: props.immCard.getIn(['limit', 'amount']),
            methodSelected: props.immCardChangePaymentMethod.get('steps').get(0).get('method'),
            precontractualMailProductInfo,
            showRevolvingDocument: props.immCardChangePaymentMethod.get('steps').get(0).get('method') !== CARD_PAYMENT_METHOD_UNIQUE,
            signatureSectionRevolving: null,
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.immCardChangePaymentMethod.get('steps').get(1).get('agreementChecked') !==
            this.props.immCardChangePaymentMethod.get('steps').get(1).get('agreementChecked')) &&
            this.props.immCardChangePaymentMethod.get('steps').get(1).get('agreementChecked'))
        {
            this.setState({signatureSectionRevolving: this.buildSignatureSection()});
        }
    }
    
    buildSignatureSection() {
        return (
            <section className="card-change-payment-method-step-two__content">
                <SignaturePattern
                    operationType={CARD_PAYMENT_CHANGE_ID}
                    operationParams={{}}
                />
            </section>
        )
    }

    buildSummary() {
        const {
            immCardChangePaymentMethod
        } = this.props;

        const { methodSelected } = this.state;

        const immStepOne = immCardChangePaymentMethod.get('steps').get(0);
        const currentMethod = immStepOne.get('currentPaymentMethod');
        const methodSelectedQuota = immStepOne.get('installments');

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('cardChangePaymentMethod-unique')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('cardChangePaymentMethod-fixed')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('cardChangePaymentMethod-variable')}`
        };

        const currentMethodText = paymentMethod[currentMethod];
        let methodSelectedText = paymentMethod[methodSelected];

        if (methodSelected !== CARD_PAYMENT_METHOD_UNIQUE) {
            methodSelectedText += ` ${methodSelectedQuota} ${methodSelected === CARD_PAYMENT_METHOD_FIXED ? formatText('currencies-EUR') : '%'}`;
        }

        return (
            <div className="card-change-payment-method-step-two__summary row">
                <div className="col-xs-12 card-change-payment-method-step-two__subtitle">
                    <FormattedText value="cardChangePaymentMethod-revolvingMessageStep2" />
                </div>
                <div className="col-xs-6 print-label">
                    <div className="card-change-payment-method-step-two__summary-label">
                        <FormattedText value="cardChangePaymentMethod-currentPaymentMethod" />
                    </div>
                    <div className="card-change-payment-method-step-two__summary-value">
                        {currentMethodText}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="card-change-payment-method-step-two__summary-label">
                        <FormattedText value="cardChangePaymentMethod-newPaymentMethod" />
                    </div>
                    <div className="card-change-payment-method-step-two__summary-value">
                        {methodSelectedText}
                    </div>
                </div>
            </div>
        );
    }

    buildRevolvingProcess() {
        const { immCardChangePaymentMethod, handleAgreementCheckboxChange } = this.props;
        const { amount, precontractualMailProductInfo } = this.state;
        const { showRevolvingDocument, signatureSectionRevolving } = this.state;
        const immSteps = immCardChangePaymentMethod.get('steps');
        
        const agreementChecked = immSteps.get(1).get('agreementChecked');

        return(
            <React.Fragment>
                <CardLegalViewerModal
                    amount={amount}
                    agreeCheckboxRevol={agreementChecked}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    isContractingProcess={false}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    showRevolvingDocument={showRevolvingDocument}
                />
                {agreementChecked && signatureSectionRevolving}
            </React.Fragment>
        )
    }

    buildContactCenterRevolvingProcess() {
        const { handleAgreementCheckboxChange, immCardChangePaymentMethod, showIneAndRevolving, contractName } = this.props;
        const { amount, precontractualMailProductInfo, showRevolvingDocument, signatureSectionRevolving } = this.state;
        const immSteps = immCardChangePaymentMethod.get('steps');
        const agreementChecked = immSteps.get(1).get('agreementChecked');
        const agreementErrorMsg = formatText('revolvingProcessDocuments-revolvingProcessDocuments_checkboxErrorMsgCC');

        let sendMailParams = {
            type: precontractualMailProductInfo.producto,
            subType: precontractualMailProductInfo.subproducto,
            standar: precontractualMailProductInfo.standard,
        };
        return (
            <React.Fragment>
                <ContactCenterValidationCards
                    agreementErrorMsg={agreementErrorMsg}
                    amount={amount}
                    contractName={contractName}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    immStep={immSteps.get(1)}
                    isContractingProcess={false}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                />
                {agreementChecked && signatureSectionRevolving}
            </React.Fragment>
        )
    }

    render() {
        const signatureSection = this.buildSignatureSection();
        const operativeName= formatText('operatives-paymentMethodChange_cards');
        const { immCard, showIneAndRevolving } = this.props;
        const titleKey = `cardChangePaymentMethod-${showIneAndRevolving ? 'revolvingTitleStep2' : 'securityConfirmation'}` ;
        const isForRevolvingProcess = immCard.get('isForRevolvingProcess');

        return (
            <article className="card-change-payment-method-step-two">
                <header className="card-change-payment-method-step-two__header">
                    <FormattedText
                        value={titleKey}
                        className="card-change-payment-method-step-two__title"
                    />
                </header>
                {showIneAndRevolving && isForRevolvingProcess && this.buildSummary()}
                <ContactCenterRender>
                    {showIneAndRevolving && isForRevolvingProcess ? (
                        this.buildContactCenterRevolvingProcess()
                    ) : (
                        <React.Fragment>
                            <ConfirmationScript
                                confirmationType={CONFIRMATION_SCRIPT_GREETING}
                                operative={operativeName}
                            />
                            {signatureSection}
                        </React.Fragment>                        
                    )}
                </ContactCenterRender>
                <WebappRender>
                    {showIneAndRevolving && isForRevolvingProcess ?
                        this.buildRevolvingProcess()
                        : signatureSection
                    }
                </WebappRender>
            </article>
        )
    }
}

CardChangePaymentMethodStep2.propTypes = {
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func,
    immCardChangePaymentMethod: PropTypes.object,
    immCard: PropTypes.object.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = CardChangePaymentMethodStep2;